import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path fill-rule="evenodd" d="m17 16 2-4V9h-7l1-3 2-3-1 6h8v1l-3 6h-2Zm0 1h3v-1l3-6V7h-7l1-4V2l-1-1-3 3-1-1-6 6H1v10h15v-1l1-1ZM6 11v7H3v-7h3Zm9 7H7v-8l4-5-1 6h8v1l-3 6Z" clip-rule="evenodd"/>',
  f: '<path fill-rule="evenodd" d="M19 17h-1l2-4v-3l-1-1-2-1h-4l1-4V3l2-2 1 1v1l-1 4h7v3l-3 6a2 2 0 0 1-1 1ZM6 19h10v-1l3-6V9h-7l1-4V4l-1-1-6 6v10Zm-2 0V9H1v10h3Z" clip-rule="evenodd"/>',
  vb: '0 0 25 21',
};

export default data;
